<script lang="ts">
  import ImageUploadItem from './ImageUploadItem.svelte';
  import { uploadReviewImageToServer } from '../../services/pdp-data-services';
  import { showSnackbar } from '../../../common/store/snackbar_store';
  import { getStr } from '../../../../common/util';
  import { getAppConfig } from '../../../../common/config/app-config';
  export let uploadItems = [];
  let id = 1;

  const { testFreaksConfig } = getAppConfig();
  const MAX_IMAGES = testFreaksConfig?.maxNumberOfImagesPerReview || 8;
  const MAX_FILE_SIZE = testFreaksConfig?.imageSize * 1024 * 1024; // 40MB in bytes
  const ALLOWED_TYPES = testFreaksConfig?.imageFormat?.split(',')?.map(fmt => `image/${fmt.trim()}`);

  function fileSelectHandler({ detail: files }) {
    const fileArray = Array.from(files);
    const remainingSlots = MAX_IMAGES - uploadItems.length;

    if (remainingSlots <= 0) {
      showSnackbar(getStr('extra.pdp.review.max.image.upload.error'), 'info');
      return;
    }

    if (fileArray.length > remainingSlots) {
      showSnackbar(getStr('extra.pdp.review.max.image.upload.error'), 'info');
    }

    const filesToUpload = fileArray.slice(0, remainingSlots);

    for (const file of filesToUpload) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        showSnackbar(getStr('extra.pdp.review.invalid.image.format.error'), 'info');
        continue;
      }

      if (file.size > MAX_FILE_SIZE) {
        showSnackbar(getStr('extra.pdp.review.invalid.image.size.error'), 'info');
        continue;
      }

      const fileUploadObject = {
        file,
        id: ++id,
        state: 'uploading',
        imageData: null,
      };

      uploadItems = [...uploadItems, fileUploadObject];
      uploadFile(fileUploadObject);
    }
  }

  async function uploadFile(fileUploadObject) {
    try {
      const imageData = await uploadReviewImageToServer(fileUploadObject.file);
      uploadItems = uploadItems.map(item =>
        item.id === fileUploadObject.id ? { ...item, state: 'done', imageData } : item
      );
    } catch (error) {
      let errorMessage = getStr('extra.pdp.review.image.upload.failed');

      if (error instanceof TypeError) {
        // Network error
        errorMessage = 'Network error: Unable to upload image. Please check your connection.';
      } else if (error?.message) {
        // Server error or validation error
        errorMessage = `Upload failed: ${error.message}`;
      }

      showSnackbar(errorMessage, 'error');
      uploadItems = uploadItems.filter(item => item.id !== fileUploadObject.id);
    }
  }

  function deleteUploadItem({ detail: id }) {
    uploadItems = [...uploadItems.filter(x => x.id !== id)];
  }
</script>

<section class="image-upload-container">
  <ImageUploadItem state="new" disabled={uploadItems.length >= MAX_IMAGES} on:fileSelect={fileSelectHandler} />
  {#each uploadItems as item (item.id)}
    <ImageUploadItem state={item.state} fileObject={item} on:delete={deleteUploadItem} />
  {/each}
</section>

<style lang="scss">
  .image-upload-container {
    display: flex;
    gap: 8px;
  }
</style>
